import styled from "styled-components";
import { utilsFonts } from "styles/font-sizes";

export const StyledText = styled.div`
  font-size: ${utilsFonts.loadingText}px;
`;
